import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-confirmation-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="confirmation-overlay">
      <div class="modal-content">
        <div class="pop-up-header">
          <img src="assets/icons/warning-popup.svg" alt="warning-icon" />
          <span>{{ title }}</span>
        </div>

        <div class="info">
          {{ message }}
        </div>

        <div class="modal-actions">
          <ng-container *ngIf="!showOnlyOkButton; else okButtonTemplate">
            <button class="save-btn" [disabled]="disableYesButton" (click)="onConfirm()">Yes</button>
            <button class="cancel-btn" (click)="onCancel()">Cancel</button>
          </ng-container>
          <ng-template #okButtonTemplate>
            <button class="ok-btn" (click)="onOk()">OK</button>
          </ng-template>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .confirmation-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
      }

      .modal-content {
        display: inline-flex;
        flex-direction: column;
        width: 480px;
        align-items: flex-start;
        border-radius: 8px;
        padding: 20px;
        background: var(--background-variant-0-ffffff, #fff);
        gap: 20px;
        box-shadow:
          0px 8px 10px 0px rgba(0, 0, 0, 0.2),
          0px 16px 24px 0px rgba(0, 0, 0, 0.14),
          0px 6px 30px 0px rgba(0, 0, 0, 0.12);
      }

      .pop-up-header {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
      }

      .pop-up-header img {
        width: 24px;
        height: 24px;
      }

      .pop-up-header span {
        color: var(--background-variant-81-e-2225, #1e2225);
        font-family: var(--Typeface-Family-Title, Lexend);
        font-size: var(--Typeface-Font-size-lg, 20px);
        font-style: normal;
        font-weight: 600;
        line-height: var(--Typeface-Line-height-23, 23px);
        letter-spacing: var(--Typeface-Letter-spacing-0, 0px);
      }

      .info {
        color: var(--background-variant-6475258, #475258);
        font-family: var(--Typeface-Family-Body, Lexend);
        font-size: var(--Typeface-Font-size-sm, 14px);
        font-style: normal;
        font-weight: 400;
        line-height: var(--Typeface-Line-height-24, 24px);
        letter-spacing: var(--Typeface-Letter-spacing-4min, -0.16px);
        white-space: pre-line;
      }

      .modal-actions {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-start;
        gap: 10px;
        width: 100%;
      }

      .save-btn {
        cursor: pointer;
        border: none;
        display: flex;
        height: 32px;
        padding: 5px 8px;
        align-items: center;
        gap: 5px;
        border-radius: 4px;
        background: var(--primary-varient-2534-ad-8, #534ad8);
        color: var(--background-variant-0-ffffff, #fff);
        font-family: var(--Typeface-Family-Body, Lexend);
        font-size: var(--Typeface-Font-size-sm, 14px);
        font-style: normal;
        font-weight: 400;
        line-height: var(--Typeface-Line-height-24, 24px);
        letter-spacing: var(--Typeface-Letter-spacing-4min, -0.16px);
      }

      .save-btn:disabled {
        background: var(--background-variant-3-bfccd-9, #bfccd9);
        cursor: not-allowed;
        color: var(--background-variant-0-ffffff, #ffffff99);
      }

      .cancel-btn {
        cursor: pointer;
        border: none;
        display: flex;
        height: 32px;
        padding: 5px 8px;
        align-items: center;
        gap: 5px;
        border-radius: 4px;
        background: var(--selection-selected-6-ebeff-5, #ebeff5);
        color: var(--background-variant-6475258, #475258);
        font-family: var(--Typeface-Family-Body, Lexend);
        font-size: var(--Typeface-Font-size-sm, 14px);
        font-style: normal;
        font-weight: 400;
        line-height: var(--Typeface-Line-height-24, 24px);
        letter-spacing: var(--Typeface-Letter-spacing-4min, -0.16px);
      }

      .ok-btn {
        cursor: pointer;
        border: none;
        display: flex;
        height: 32px;
        padding: 5px 8px;
        align-items: center;
        gap: 5px;
        border-radius: 4px;
        background: var(--primary-varient-2534-ad-8, #534ad8);
        color: var(--background-variant-0-ffffff, #fff);
        font-family: var(--Typeface-Family-Body, Lexend);
        font-size: var(--Typeface-Font-size-sm, 14px);
        font-style: normal;
        font-weight: 400;
        line-height: var(--Typeface-Line-height-24, 24px);
        letter-spacing: var(--Typeface-Letter-spacing-4min, -0.16px);
      }
    `,
  ],
})
export class ConfirmationOverlayComponent {
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  title: string = '';
  message: string = '';
  disableYesButton: boolean = false;
  showOnlyOkButton: boolean = false;

  onConfirm() {
    if (!this.disableYesButton) {
      this.confirm.emit();
    }
  }

  onCancel() {
    this.cancel.emit();
  }

  onOk() {
    this.cancel.emit();
  }
}
